import React, { useEffect, useRef, useState } from 'react'
import './styles.css'
import { Calendar, House, Location, SearchNormal1, User } from 'iconsax-react'
import HotelSearchCard from '../../../../Components/HotelSearchCard/HotelSearchCard'
import HotelDateCard from '../../../../Components/HotelDateCard/HotelDateCard'
import HotelRoomsCard from '../../../../Components/HotelRoomsCard/HotelRoomsCard'
import axios from 'axios'
import UseHotels from '../../../viewModels/hotels/UseHotels'
import SvgIcon, { iconList } from '../../share/components/iconSVG'
import { CircularProgress } from '@mui/material'



const HotelSearchEngine = ({ titleSize, iconTitleSize, containDateFlexDirection, containDateJustify, layoutCampoWidth, containFinishFlexDirection, containFinishJustify, layoutCampoVWidth, widthContain, right, position, top }) => {

  const {
    cardRef,
    openHotelSearch,
    setOpenHotelSearch,
    paceholders,
    setPaceholders,
    search,
    setSearch,
    destiny,
    setDestiny,
    destinitySelected,
    setDestinitySelected,
    dateEntry,
    setDateEntry,
    datesSelected,
    setDatesSelected,
    quantity,
    cardRooms,
    setCardRooms,
    roomsSelected,
    setRoomsSelected,
    quantityPersons,
    setQuantityPersons,
    openHotelSearchFuct,
    destinationSelectionFunc,
    searchHotelSelected,
    findCountryClient,
    nacionalityDropdown,
    setNacionalityDropdown,
    dataNacionality,
    selectedNacionality,
    nacionality,
    codeNacionality,
    loading,
    loadingSearch,
    validationForm
  } = UseHotels()

  return (
    <div className='container_campoSearch_' style={{ width: `${widthContain}`, right: `${right}`, position: `${position}`, top: `${top}` }}>
      <div className='contain-header-buscador-hotel'>
        <House size={iconTitleSize} color="#004274" />
        <h3 style={{ fontSize: `${titleSize}` }}>Alojamiento</h3>
      </div>
      <div className='contain-campos'>
        <div className='layout-campo' style={{ width: '100%' }} onClick={openHotelSearchFuct}>
          <div className='destiny-hotel'>
            <span>Destino</span>
            <p>{paceholders === '' ? 'Escoge tu destino' : paceholders}</p>
          </div>
          <div>
            <Location size="32" color="#004274" />
          </div>
        </div>
        {openHotelSearch &&
          <HotelSearchCard cardRef={cardRef} search={search} setSearch={setSearch} placeholder={paceholders} destiny={destiny} destinationSelectionFunc={destinationSelectionFunc} />
        }
        <div className='contain_date' style={{ flexDirection: `${containDateFlexDirection}`, justifyContent: `${containDateJustify}` }} >
          <div className='layout-campo' style={{ width: `${layoutCampoWidth}` }} onClick={() => setDateEntry(!dateEntry)}>
            <div className='destiny-hotel'>
              <span>Fecha</span>
              <p>{datesSelected.entryDate}</p>
            </div>
            <div>
              <Calendar size="32" color="#004274" />
            </div>
          </div>
          {dateEntry &&
            <HotelDateCard cardRef={cardRef} setDatesSelected={setDatesSelected} setDateEntry={setDateEntry} left={'0'} />
          }
          <div className='layout-campo' style={{ width: `${layoutCampoWidth}` }}>
            <div className='destiny-hotel'>
              <span>Fecha</span>
              <p>{datesSelected.exitDate}</p>
            </div>
            <div>
              <Calendar size="32" color="#004274" />
            </div>
          </div>
        </div>
        <div className='contain-finish' style={{ flexDirection: `${containFinishFlexDirection}`, justifyContent: `${containFinishJustify}` }}>
          <div className='layout-campo' style={{ cursor: 'pointer', width: `${layoutCampoWidth}` }} onClick={() => setCardRooms(!cardRooms)}>
            <div className='destiny-hotel' style={{ gap: '5px' }}>
              <span>Habitaciones</span>
              <div className='contain_rooms'>
                <div className='contain_rooms_'>
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="sbox5-3-bed-svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M8 2C6.34315 2 5 3.34315 5 5V10.1707C3.83481 10.5825 3 11.6938 3 13V22C3 22.5523 3.44772 23 4 23C4.55229 23 5 22.5523 5 22L5 19H19V22C19 22.5523 19.4477 23 20 23C20.5523 23 21 22.5523 21 22V13C21 11.6938 20.1652 10.5825 19 10.1707V5C19 3.34315 17.6569 2 16 2H8ZM8 10H7V5C7 4.44772 7.44772 4 8 4H16C16.5523 4 17 4.44772 17 5V10H16V8C16 6.89543 15.1046 6 14 6H10C8.89543 6 8 6.89543 8 8V10ZM10 10H14V8H10V10ZM6 12C5.44772 12 5 12.4477 5 13V17H19V13C19 12.4477 18.5523 12 18 12H6Z" fill="#004274"></path>
                  </svg>
                  <p>1</p>
                </div>
                <div className='contain_rooms_'>
                  <User size="32" color="#004274" />
                  <p>{quantityPersons}</p>
                </div>
              </div>
            </div>
          </div>
          {cardRooms &&
            <HotelRoomsCard cardRef={cardRef} roomsSelected={roomsSelected} setRoomsSelected={setRoomsSelected} setCardRooms={setCardRooms} cardRooms={cardRooms} />
          }
          <div className='layout-campo-v' style={{ width: `${layoutCampoVWidth}` }}>
            <div className='destiny-hotel' onClick={() => { setNacionalityDropdown(!nacionalityDropdown) }} style={{ gap: '5px' }}>
              <span>Nacionalidad</span>
              <div className='contain-nacionality'>
                <SvgIcon name={iconList.IconBag} color={'#004274'} size={30} />
                <p>{nacionality === '' ? 'Selecciona' : `${nacionality}, ${codeNacionality}`}</p>
              </div>
            </div>
            {
              nacionalityDropdown &&
              <div className='dropdown-nacionality'>
                <div >
                  <input type="text" onChange={(e) => { findCountryClient(e.target.value) }} />
                  {
                    loading &&
                    <CircularProgress style={{ position: 'absolute', right: '20px', top: '20px' }} size={25} />
                  }

                </div>

                <ul>
                  {
                    dataNacionality.length >= 1 &&
                    dataNacionality.map((item, key) => {
                      return (
                        <li key={key} onClick={() => {
                          selectedNacionality(item.code, item.name)
                          setNacionalityDropdown(false)
                        }}>
                          {item.name}, {item.code}
                        </li>
                      )
                    })
                  }
                </ul>
              </div>
            }
          </div>
          <div className='layout-campo-v' style={{ width: `100%`, PointerEvent: loadingSearch ? 'none' : 'auto', opacity: loadingSearch ? 0.5 : 1 }} onClick={searchHotelSelected}>
            <div>
              {
                loadingSearch === true ?
                  <CircularProgress size={25} />
                  :

                  <SearchNormal1 size="45" color="#004274" />
              }

            </div>
          </div>
          {
            validationForm &&
            <div className='error-hotel-search'>
              <p>Por favor llena todos los campos</p>
            </div>
          }

        </div>
      </div>
    </div>
  )
}

export default HotelSearchEngine